var _feFlood, _feComposite, _feGaussianBlur, _feOffset, _feComposite2, _feFlood2, _feComposite3, _feGaussianBlur2, _feOffset2, _feComposite4, _feFlood3, _feComposite5, _feGaussianBlur3, _feOffset3, _feComposite6, _feFlood4, _feComposite7, _feGaussianBlur4, _feOffset4, _feComposite8, _feColorMatrix, _feFlood5, _feComposite9, _feGaussianBlur5, _feOffset5, _feComposite10, _feFlood6, _feComposite11, _feGaussianBlur6, _feOffset6, _feComposite12, _feColorMatrix2, _feFlood7, _feComposite13, _feGaussianBlur7, _feOffset7, _feComposite14, _feFlood8, _feComposite15, _feGaussianBlur8, _feOffset8, _feComposite16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocalRemoteKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg3805",
    viewBox: "0 0 109.84477 46.052632",
    height: 125,
    width: 194.625,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs3800"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "filter4374",
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood || (_feFlood = /*#__PURE__*/React.createElement("feFlood", {
    id: "feFlood4364",
    result: "flood",
    floodColor: "rgb(0,0,0)",
    floodOpacity: 1
  })), _feComposite || (_feComposite = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite4366",
    result: "composite1",
    operator: "in",
    in2: "SourceGraphic",
    in: "flood"
  })), _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur4368",
    result: "blur",
    stdDeviation: 2,
    in: "composite1"
  })), _feOffset || (_feOffset = /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset4370",
    result: "offset",
    dy: 0,
    dx: 0
  })), _feComposite2 || (_feComposite2 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite4372",
    result: "composite2",
    operator: "over",
    in2: "offset",
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter4374-3",
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood2 || (_feFlood2 = /*#__PURE__*/React.createElement("feFlood", {
    id: "feFlood4364-7",
    result: "flood",
    floodColor: "rgb(0,0,0)",
    floodOpacity: 1
  })), _feComposite3 || (_feComposite3 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite4366-5",
    result: "composite1",
    operator: "in",
    in2: "SourceGraphic",
    in: "flood"
  })), _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur4368-9",
    result: "blur",
    stdDeviation: 2,
    in: "composite1"
  })), _feOffset2 || (_feOffset2 = /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset4370-2",
    result: "offset",
    dy: 0,
    dx: 0
  })), _feComposite4 || (_feComposite4 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite4372-2",
    result: "composite2",
    operator: "over",
    in2: "offset",
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter4374-9",
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood3 || (_feFlood3 = /*#__PURE__*/React.createElement("feFlood", {
    id: "feFlood4364-73",
    result: "flood",
    floodColor: "rgb(0,0,0)",
    floodOpacity: 1
  })), _feComposite5 || (_feComposite5 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite4366-6",
    result: "composite1",
    operator: "in",
    in2: "SourceGraphic",
    in: "flood"
  })), _feGaussianBlur3 || (_feGaussianBlur3 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur4368-1",
    result: "blur",
    stdDeviation: 2,
    in: "composite1"
  })), _feOffset3 || (_feOffset3 = /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset4370-29",
    result: "offset",
    dy: 0,
    dx: 0
  })), _feComposite6 || (_feComposite6 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite4372-3",
    result: "composite2",
    operator: "over",
    in2: "offset",
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter4830",
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood4 || (_feFlood4 = /*#__PURE__*/React.createElement("feFlood", {
    id: "feFlood4820",
    result: "flood",
    floodColor: "rgb(0,0,0)",
    floodOpacity: 1
  })), _feComposite7 || (_feComposite7 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite4822",
    result: "composite1",
    operator: "in",
    in2: "SourceGraphic",
    in: "flood"
  })), _feGaussianBlur4 || (_feGaussianBlur4 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur4824",
    result: "blur",
    stdDeviation: 1.8,
    in: "composite1"
  })), _feOffset4 || (_feOffset4 = /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset4826",
    result: "offset",
    dy: -0.1,
    dx: -0.1
  })), _feComposite8 || (_feComposite8 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite4828",
    result: "fbSourceGraphic",
    operator: "over",
    in2: "offset",
    in: "SourceGraphic"
  })), _feColorMatrix || (_feColorMatrix = /*#__PURE__*/React.createElement("feColorMatrix", {
    id: "feColorMatrix8694",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha"
  })), _feFlood5 || (_feFlood5 = /*#__PURE__*/React.createElement("feFlood", {
    in: "fbSourceGraphic",
    result: "flood",
    floodColor: "rgb(0,0,0)",
    floodOpacity: 1,
    id: "feFlood8696"
  })), _feComposite9 || (_feComposite9 = /*#__PURE__*/React.createElement("feComposite", {
    result: "composite1",
    operator: "in",
    in: "flood",
    id: "feComposite8698",
    in2: "fbSourceGraphic"
  })), _feGaussianBlur5 || (_feGaussianBlur5 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 0.1,
    in: "composite1",
    id: "feGaussianBlur8700"
  })), _feOffset5 || (_feOffset5 = /*#__PURE__*/React.createElement("feOffset", {
    result: "offset",
    dy: 0,
    dx: 0,
    id: "feOffset8702"
  })), _feComposite10 || (_feComposite10 = /*#__PURE__*/React.createElement("feComposite", {
    result: "composite2",
    operator: "over",
    in: "fbSourceGraphic",
    id: "feComposite8704",
    in2: "offset"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter8848",
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood6 || (_feFlood6 = /*#__PURE__*/React.createElement("feFlood", {
    id: "feFlood8838",
    result: "flood",
    floodColor: "rgb(0,0,0)",
    floodOpacity: 1
  })), _feComposite11 || (_feComposite11 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite8840",
    result: "composite1",
    operator: "in",
    in2: "SourceGraphic",
    in: "flood"
  })), _feGaussianBlur6 || (_feGaussianBlur6 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur8842",
    result: "blur",
    stdDeviation: 1,
    in: "composite1"
  })), _feOffset6 || (_feOffset6 = /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset8844",
    result: "offset",
    dy: -0.1,
    dx: -0.1
  })), _feComposite12 || (_feComposite12 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite8846",
    result: "fbSourceGraphic",
    operator: "over",
    in2: "offset",
    in: "SourceGraphic"
  })), _feColorMatrix2 || (_feColorMatrix2 = /*#__PURE__*/React.createElement("feColorMatrix", {
    id: "feColorMatrix8874",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha"
  })), _feFlood7 || (_feFlood7 = /*#__PURE__*/React.createElement("feFlood", {
    in: "fbSourceGraphic",
    result: "flood",
    floodColor: "rgb(63,63,63)",
    floodOpacity: 1,
    id: "feFlood8876"
  })), _feComposite13 || (_feComposite13 = /*#__PURE__*/React.createElement("feComposite", {
    result: "composite1",
    operator: "in",
    in: "flood",
    id: "feComposite8878",
    in2: "fbSourceGraphic"
  })), _feGaussianBlur7 || (_feGaussianBlur7 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 2,
    in: "composite1",
    id: "feGaussianBlur8880"
  })), _feOffset7 || (_feOffset7 = /*#__PURE__*/React.createElement("feOffset", {
    result: "offset",
    dy: -0.1,
    dx: -0.1,
    id: "feOffset8882"
  })), _feComposite14 || (_feComposite14 = /*#__PURE__*/React.createElement("feComposite", {
    result: "composite2",
    operator: "over",
    in: "fbSourceGraphic",
    id: "feComposite8884",
    in2: "offset"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter9033",
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood8 || (_feFlood8 = /*#__PURE__*/React.createElement("feFlood", {
    id: "feFlood9023",
    result: "flood",
    floodColor: "rgb(63,63,63)",
    floodOpacity: 1
  })), _feComposite15 || (_feComposite15 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite9025",
    result: "composite1",
    operator: "in",
    in2: "SourceGraphic",
    in: "flood"
  })), _feGaussianBlur8 || (_feGaussianBlur8 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur9027",
    result: "blur",
    stdDeviation: 1,
    in: "composite1"
  })), _feOffset8 || (_feOffset8 = /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset9029",
    result: "offset",
    dy: -0.1,
    dx: -0.1
  })), _feComposite16 || (_feComposite16 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite9031",
    result: "composite2",
    operator: "over",
    in2: "offset",
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1.73582,0,0,1.73582,3.0780754,1.7436281)",
    ry: 1.0085174,
    rx: 0.93072182,
    y: -4.7474341,
    x: 1.4912233,
    height: 34.506004,
    width: 56.989555,
    id: "rect3807",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#d5d5d5",
      fillOpacity: 1,
      stroke: "#010000",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0.87830685,
      paintOrder: "stroke fill markers",
      filter: "url(#filter9033)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    ry: 1.7273538,
    rx: 1.5941081,
    y: -6.0384941,
    x: 6.2567573,
    height: 59.1007,
    width: 97.609734,
    id: "rect3807-9",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#010000",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0.87830685,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "text995-4",
    y: 0.64312655,
    x: 50.679035,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "28.21594238px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      display: "inline",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.7053985
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 600,
      fontStretch: "normal",
      fontSize: "5.643188px",
      fontFamily: "Crossten",
      InkscapeFontSpecification: "'Crossten Semi-Bold'",
      strokeWidth: 0.7053985
    },
    y: 0.64312655,
    x: 50.679035,
    id: "tspan993-7"
  }, "Key")), /*#__PURE__*/React.createElement("path", {
    id: "path3779-3-8",
    style: {
      clipRule: "evenodd",
      fill: "none",
      fillRule: "evenodd",
      stroke: "#3f3f3f",
      strokeWidth: 0.40327796,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      shapeRendering: "geometricPrecision"
    },
    d: "m 94.48746,26.342111 c -0.518948,0.01338 -1.034919,0.08425 -1.536592,0.218352 -2.59063,0.694137 -4.476486,2.918257 -4.722976,5.570041 0.246507,-2.651784 2.132346,-4.875904 4.722976,-5.570041 0.501664,-0.13437 1.017644,-0.207954 1.536592,-0.218352 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3783-4",
    style: {
      clipRule: "evenodd",
      fill: "none",
      fillRule: "evenodd",
      stroke: "#3f3f3f",
      strokeWidth: 0.40327796,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      shapeRendering: "geometricPrecision"
    },
    d: "m 94.531048,28.016326 c -0.316457,0.01338 -0.630275,0.06318 -0.936171,0.145825 -1.840751,0.493117 -3.164252,2.109877 -3.298213,4.028678 0.133971,-1.918801 1.457462,-3.535481 3.298213,-4.028678 0.305896,-0.08212 0.619706,-0.130889 0.936171,-0.145825 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f3f3f",
      strokeWidth: 0.53012651,
      shapeRendering: "geometricPrecision"
    },
    d: "m 95.720927,32.927554 0.6134,0.613356 h 2.278202 c 0.159697,0 0.289156,0.129301 0.289156,0.289055 v 2.602462 c 0,0.159695 -0.129459,0.289055 -0.289156,0.289055 h -2.602437 c -0.159731,0 -0.289165,-0.129302 -0.289165,-0.289055 V 34.154239 L 95.107528,33.54091 h -2.2782 c -0.159694,0 -0.289163,-0.129301 -0.289163,-0.289031 v -2.60246 c 0,-0.159696 0.129459,-0.289055 0.289163,-0.289055 h 2.602443 c 0.159696,0 0.289156,0.1293 0.289156,0.289055 z m -2.313284,-1.699943 v 1.445839 h 1.4458 v -1.445839 z m 3.180763,3.180785 v 1.445758 h 1.445799 v -1.445758 z",
    id: "path3857-50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3779-3-3-3",
    style: {
      clipRule: "evenodd",
      display: "inline",
      fill: "#808080",
      fillRule: "evenodd",
      stroke: "#3f3f3f",
      strokeWidth: 0.42240992,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      shapeRendering: "geometricPrecision"
    },
    d: "m 94.8964,37.657273 c -0.543565,0.01338 -1.084005,0.08825 -1.609486,0.22875 -2.713534,0.727091 -4.688856,3.056681 -4.947046,5.834275 0.258184,-2.777594 2.233512,-5.107184 4.947046,-5.834275 0.525464,-0.140774 1.065921,-0.217819 1.609486,-0.22875 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3783-6-6",
    style: {
      clipRule: "evenodd",
      fill: "#3f3f3f",
      fillRule: "evenodd",
      stroke: "#3f3f3f",
      strokeWidth: 0.42240992,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      shapeRendering: "geometricPrecision"
    },
    d: "m 94.902425,39.331647 c -0.331483,0.01338 -0.660183,0.06611 -0.980588,0.152769 -1.928079,0.5165 -3.314359,2.209964 -3.454682,4.219782 0.140323,-2.009818 1.526603,-3.703202 3.454682,-4.219782 0.320405,-0.08612 0.649105,-0.137043 0.980588,-0.152769 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f3f3f",
      strokeWidth: 0.54124707,
      shapeRendering: "geometricPrecision"
    },
    id: "path6096-1",
    d: "m 93.606807,42.417788 v 4.723616 H 98.33042 V 42.417788 Z M 93.01635,41.532119 h 5.904523 c 0.163057,0 0.295216,0.132238 0.295216,0.295215 v 5.904524 c 0,0.163168 -0.132178,0.295215 -0.295216,0.295215 H 93.01635 c -0.163028,0 -0.295222,-0.132239 -0.295222,-0.295215 v -5.904524 c 0,-0.163168 0.132186,-0.295215 0.295222,-0.295215 z m 4.034515,3.252209 c 0.0568,0.03145 0.08905,0.08025 0.09695,0.146366 0.0075,0.06611 -0.01181,0.122922 -0.0591,0.17009 l -1.480401,1.398197 c -0.03471,0.03467 -0.0788,0.05199 -0.132424,0.05199 -0.06934,0 -0.123764,-0.02985 -0.163167,-0.08985 -0.03944,-0.05971 -0.04656,-0.121309 -0.02134,-0.184226 l 0.425677,-1.020307 -0.832428,-0.481814 c -0.05362,-0.03145 -0.08513,-0.08024 -0.09463,-0.146363 -0.0096,-0.06611 0.0096,-0.122923 0.0568,-0.170094 l 1.480397,-1.398195 c 0.04106,-0.03467 0.08513,-0.05199 0.132426,-0.05199 0.05361,0 0.100101,0.01866 0.13954,0.05891 0.03944,0.03946 0.0591,0.08585 0.0591,0.139438 0,0.03145 -0.0064,0.05971 -0.01894,0.08506 l -0.420945,1.010869 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 92.89438,18.960261 v 5.130163 h 5.130174 V 18.960261 Z M 92.253108,17.99834 h 6.412714 c 0.177084,0 0.320647,0.143435 0.320647,0.320649 v 6.412706 c 0,0.177027 -0.143573,0.32065 -0.320647,0.32065 h -6.412714 c -0.177079,0 -0.320631,-0.143709 -0.320631,-0.32065 v -6.412706 c 0,-0.177026 0.143535,-0.320649 0.320631,-0.320649 z m 4.381768,3.532122 c 0.06166,0.03413 0.09672,0.08718 0.105312,0.158897 0.0085,0.07173 -0.01273,0.133311 -0.0642,0.184758 l -1.607816,1.518543 c -0.03768,0.0376 -0.08562,0.05652 -0.143829,0.05652 -0.07534,0 -0.134389,-0.03253 -0.177214,-0.09757 -0.04284,-0.06505 -0.0505,-0.131693 -0.02319,-0.199954 l 0.462312,-1.108127 -0.904073,-0.523298 c -0.05821,-0.03413 -0.09246,-0.08718 -0.102727,-0.159157 -0.0101,-0.07173 0.0101,-0.133311 0.06166,-0.184759 l 1.607864,-1.518516 c 0.04448,-0.0376 0.09246,-0.05652 0.14383,-0.05652 0.05819,0 0.108711,0.02134 0.151538,0.06399 0.04282,0.04292 0.0642,0.09332 0.0642,0.151433 0,0.03413 -0.007,0.06505 -0.02054,0.09252 l -0.457156,1.097867 z",
    id: "path6096-7-0",
    style: {
      fill: "#061e37",
      strokeWidth: 0.58783221,
      shapeRendering: "geometricPrecision"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3857-5-6",
    d: "m 95.228996,9.3937484 0.680217,0.6801686 h 2.526337 c 0.177104,0 0.320647,0.143434 0.320647,0.320542 v 2.885918 c 0,0.177295 -0.143563,0.320543 -0.320647,0.320543 h -2.885902 c -0.177108,0 -0.320636,-0.143435 -0.320636,-0.320543 v -2.526344 l -0.680219,-0.680116 h -2.526349 c -0.177107,0 -0.320651,-0.1434332 -0.320651,-0.3205153 V 6.8674573 c 0,-0.1770265 0.143533,-0.3205148 0.320651,-0.3205148 h 2.885899 c 0.17708,0 0.320653,0.1434337 0.320653,0.3205148 z M 92.663757,7.5086747 v 1.6032961 h 1.603272 V 7.5086747 Z m 3.527204,3.5272153 v 1.603243 h 1.603274 V 11.03589 Z",
    style: {
      fill: "#061e37",
      strokeWidth: 0.58786756,
      shapeRendering: "geometricPrecision"
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "text1803-3",
    y: 13.33396,
    x: 69.624535,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "4.70265722px",
      lineHeight: 1.25,
      fontFamily: "Crossten",
      InkscapeFontSpecification: "Crossten",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#061e37",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.7053985
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 600,
      fontStretch: "normal",
      fontSize: "5.643188px",
      fontFamily: "Crossten",
      InkscapeFontSpecification: "'Crossten Semi-Bold'",
      fill: "#061e37",
      fillOpacity: 1,
      strokeWidth: 0.7053985
    },
    y: 13.33396,
    x: 69.624535,
    id: "tspan1801-20"
  }, "Node ")), /*#__PURE__*/React.createElement("text", {
    id: "text1803-6-6",
    y: 36.577682,
    x: 48.04644,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "4.70265722px",
      lineHeight: 1.25,
      fontFamily: "Crossten",
      InkscapeFontSpecification: "Crossten",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.7053985
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontSize: "5.643188px",
      fill: "#3f3f3f",
      fillOpacity: 1,
      strokeWidth: 0.7053985
    },
    y: 36.577682,
    x: 48.04644,
    id: "tspan1801-2-1"
  }, "Remote Node")), /*#__PURE__*/React.createElement("text", {
    id: "text1803-6-2-5",
    y: 47.829121,
    x: 44.819237,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "4.70265722px",
      lineHeight: 1.25,
      fontFamily: "Crossten",
      InkscapeFontSpecification: "Crossten",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.7053985
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontSize: "5.643188px",
      fill: "#3f3f3f",
      fillOpacity: 1,
      strokeWidth: 0.7053985
    },
    y: 47.829121,
    x: 44.819237,
    id: "tspan1801-2-7-5"
  }, "Remote Device")), /*#__PURE__*/React.createElement("text", {
    id: "text1803-0-4",
    y: 23.586586,
    x: 66.22718,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "4.70265722px",
      lineHeight: 1.25,
      fontFamily: "Crossten",
      InkscapeFontSpecification: "Crossten",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#061e37",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.7053985
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 600,
      fontStretch: "normal",
      fontSize: "5.643188px",
      fontFamily: "Crossten",
      InkscapeFontSpecification: "'Crossten Semi-Bold'",
      fill: "#061e37",
      fillOpacity: 1,
      strokeWidth: 0.7053985
    },
    y: 23.586586,
    x: 66.22718,
    id: "tspan1801-9-7"
  }, "Device")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalRemoteKey);
export default __webpack_public_path__ + "static/media/local-remote-key.fd38d616bd72e2f6695e74a899e6f073.svg";
export { ForwardRef as ReactComponent };